import React, { Component } from 'react';
import {
  bool,
  string,
  number,
  func,
  PropTypes,
} from 'prop-types';
import {
  Card, Input, Small, Icon,
} from 'components/common';
import Tooltip from 'components/common/Tooltip';

import './SelectPanel.scss';

export default class SelectPanel extends Component {
  static propTypes = {
    notBordered: bool,
    queryParam: string.isRequired,
    value: number,
    onChange: func,
    description: string,
    options: PropTypes.arrayOf(PropTypes.shape({
      value: string.isRequired,
      label: string.isRequired,
    })),
    placeholder: string,
    name: PropTypes.shape({
      display: string,
    }),
    tooltip: PropTypes.shape({
      display: string,
      key: string,
    }),
  };

  static defaultProps = {
    value: 0,
    notBordered: false,
    onChange: null,
    description: null,
    options: [{ label: '', value: 0 }],
    placeholder: '',
    name: {},
    tooltip: {
      display: '',
      key: '',
    },
  };

  constructor(props) {
    super(props);
    this.localOnChange = this.localOnChange.bind(this);
  }

  localOnChange(value) {
    const { onChange, queryParam } = this.props;
    if (onChange) {
      onChange({ value, queryParam });
    }
  }

  render() {
    const {
      value: propValue,
      notBordered,
      name: {
        display,
      },
      description,
      options,
      placeholder,
      tooltip,
      queryParam,
    } = this.props;

    const genNewOptions = options.map(({ value: label, name: value }) => ({
      label,
      value,
    }));

    return (
      <Card.Content notBordered={notBordered}>
        <div className="filter-select-panel" data-selector-type="select-panel">
          <Input
            dataSelectorId={queryParam}
            title={display}
            as="select"
            placeholder={placeholder}
            onChange={this.localOnChange}
            value={propValue || ''}
            options={genNewOptions}
          />
          {tooltip.display && (
            <Tooltip id="select-panel-info" text={tooltip.display} position="top">
              <Icon name="info" secondary small />
            </Tooltip>
          )}
        </div>
        {description && (
          <Small secondary>
            {description}
          </Small>
        )}
      </Card.Content>
    );
  }
}
